@if (avatarBase64) {
  <ion-avatar>
    <img [src]="avatarBase64" />
  </ion-avatar>
} @else {
  <div>
    <span>{{ initials }}</span>
  </div>
}
